import {
    type RecordStage,
} from "@hg/recall-frame"
import { useActivityStatus, useJoinedTeam } from "@/hooks"
import cls from "classnames"
import { type Dispatch, useEffect, useMemo, useState } from "react"

import InviteCodeModal from "@/components/InviteCodeModal"
import StrokeText from "@/components/StrokeText"
import { i18n } from "@/i18n"

import styles from "./index.module.scss"

interface SwitcherRef {
    setCurrent: Dispatch<RecordStage>
}

interface EncodeProps {
    switcherRef: React.RefObject<SwitcherRef | null>
}

export const Encode: React.FC<EncodeProps> = ({ switcherRef }) => {
    const { data: team } = useJoinedTeam()
    const { data: actStatus } = useActivityStatus()

    const validActUser = actStatus?.isRecallUser ?? false

    // 判断是否应该显示弹窗：是召回用户 + 数据加载完 + 未加入队伍
    const shouldShowModal = useMemo(() => {
        return validActUser && team !== undefined && !team?.captainUid
    }, [validActUser, team])

    const [showModal, setShowModal] = useState(false)
    useEffect(() => {
        if (shouldShowModal) {
            setShowModal(true)
        }
    }, [shouldShowModal])

    return (
        <div className={styles.encode}>
            {!validActUser ? (
                // 不符合条件，不是召回用户
                <div className={cls(styles.tips, styles.large)}>
                    <div className={styles.arrow} />
                    <div className={styles.text}>
                        {i18n
                            .getRecall("record.not_recall_or_new_player")
                            .split("\n")
                            .map((line, index) => (
                                <StrokeText
                                    key={index}
                                    text={line}
                                    fontFamily="source-han-sans-japanese"
                                    fontWeight={700}
                                    fontSize={36}
                                    fillColor="#fff9ed"
                                    borderWidth={3}
                                    borderColor="#614518"
                                    offsetY={0}
                                    padding={3}
                                    baselineAligned
                                />
                            ))}
                    </div>
                    <div className={styles.arrow} />
                </div>
            ) : team?.captainUid ? (
                // 已经加入别的队伍
                <div className={cls(styles.tips, styles.small)}>
                    <div className={styles.arrow} />
                    <div className={styles.text}>
                        <StrokeText
                            text={i18n.getRecall("record.combine_joinedTeam_1")}
                            fontFamily="source-han-sans-japanese"
                            fontWeight={700}
                            fontSize={36}
                            fillColor="#fff9ed"
                            borderWidth={3}
                            borderColor="#614518"
                            offsetY={0}
                            padding={3}
                            baselineAligned
                        />
                        <StrokeText
                            text={`Dr.${team?.captainNickname || "unknown"}`}
                            fontSize={36}
                            fillColor="#fff9ed"
                            borderWidth={3}
                            borderColor="#614518"
                            offsetY={0}
                            padding={3}
                            baselineAligned
                            className={styles.nickname}
                        />
                        <StrokeText
                            text={i18n.getRecall("record.combine_joinedTeam_2")}
                            fontFamily="source-han-sans-japanese"
                            fontWeight={700}
                            fontSize={36}
                            fillColor="#fff9ed"
                            borderWidth={3}
                            borderColor="#614518"
                            offsetY={0}
                            padding={3}
                            baselineAligned
                        />
                    </div>
                    <div className={styles.arrow} />
                </div>
            ) : null}
            <InviteCodeModal
                open={showModal}
                onCancel={() => {
                    setShowModal(false)
                    switcherRef.current?.setCurrent("award")
                }}
            />
        </div>
    )
}

export default Encode
